import React, { FC } from 'react'
import styled from 'styled-components'
import { Icon } from 'ui/icon'

export type Props = {
  text?: string
  width?: string
  height?: string
}

export const StageError: FC<Props> = ({ children, height = '50rem', ...restProps }) => {
  return (
    <StyledLoadingError height={height} {...restProps}>
      <IconWrapper>
        <Icon name={'info'} size={2} />
      </IconWrapper>
      <span>{children}</span>
    </StyledLoadingError>
  )
}

const IconWrapper = styled.div`
  color: ${(props) => props.theme.palette.alert};
`

const Check = styled.div`
  text-transform: uppercase;
  margin-top: -1rem;
  margin-bottom: 1rem;
  ${(props) => props.theme.textStyles.h6};
`

const StyledLoadingError = styled.div<Props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};

  span {
    color: ${({ theme }) => theme.palette.grey[500]};
    ${({ theme }) => theme.textStyles.p1};
  }

  img {
    max-width: 5.7rem;
    width: 100%;
    height: auto;
    margin-bottom: 1rem;
  }
`
